import { HttpClient, HttpHeaders } from '@angular/common/http';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Environment } from '@shared/data-access/interfaces';
import { Injectable } from '@angular/core';
import { MediaType } from '@shared/data-access/enums';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PaymentDao {
	private httpHeaders = new HttpHeaders({
		Accept: MediaType.WILDCARD,
		'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.medium}`
	});
	constructor(private http: HttpClient, private environment: Environment) { }

	 public getPaymentsScriptConfig(configURL: string): Observable<any> {
		// HTTP Options
		const httpOptions = {
			headers: this.httpHeaders
		};
		return this.http.get(`${ configURL }`, httpOptions);
	}

	public getAfterPayScriptConfig(): Observable<any> {
		const httpOptions = {
			headers: this.httpHeaders
		};
		return this.http.get(`${this.environment.thirdParty.afterPay.scriptConfig}`, httpOptions);
	}
}
